// Utilities for various filtering stuff in the code.

type KeyT = number | string | symbol;

export type FilterT<T extends KeyT> = Partial<Record<T, true>> | undefined;

export function areEqualFilters<T extends KeyT>(
  a: FilterT<T>,
  b: FilterT<T>,
): boolean {
  if (!a || !b) return a === b;

  for (const key of Object.keys(a) as T[]) {
    if (!b[key]) return false;
  }

  for (const key of Object.keys(b) as T[]) {
    if (!a[key]) return false;
  }

  return true;
}

export function cloneFilter<T extends KeyT>(filter: FilterT<T>): FilterT<T>;

export function cloneFilter<T extends KeyT>(
  filter: FilterT<T>,
  withExplicitAll: readonly T[],
): Exclude<FilterT<T>, undefined>;

export function cloneFilter<T extends KeyT>(
  filter: FilterT<T>,
  withExplicitAll?: readonly T[],
): FilterT<T> {
  if (filter) return { ...filter };

  if (withExplicitAll) {
    const res: FilterT<T> = {};
    for (const key of withExplicitAll) res[key] = true;
    return res;
  }

  return undefined;
}

export function isAllSelected<T extends KeyT>(
  filter: FilterT<T>,
  all: readonly T[],
): boolean {
  if (filter) {
    for (const key of all) {
      if (!filter[key]) return false;
    }
  }

  return true;
}

export function filterToArray<T extends KeyT>(
  filter: FilterT<T>,
): T[] | undefined {
  return filter && (Object.keys(filter) as Array<keyof typeof filter>);
}
